// extracted by mini-css-extract-plugin
export var active = "_88-2";
export var container = "_88-0";
export var expired = "_88-3";
export var hasStatus = "_88-4";
export var statusChip = "_88-1";